// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS,
  FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE,
  FETCH_SHOP_BY_LOOK_UNBXD_REQUEST,
  FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS,
  FETCH_SHOP_BY_LOOK_UNBXD_FAILURE,
} from './ShopByLookStylitics.constants';

export const fetchShopByLookStyliticsRequest = (tagName, count, uniqueKey, isRedirectToPDP) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  payload: { tagName, count, uniqueKey, isRedirectToPDP },
});

export const fetchShopByLookStyliticsSuccess = (uniqueKey, data) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS,
  payload: { uniqueKey, data },
});

export const fetchShopByLookStyliticsFailure = (uniqueKey, error) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE,
  payload: { uniqueKey, error },
});

export const fetchShopByLookUnbxdRequest = (productIds, uniqueKey) => ({
  type: FETCH_SHOP_BY_LOOK_UNBXD_REQUEST,
  payload: { productIds, uniqueKey },
});

export const fetchShopByLookUnbxdSuccess = (uniqueKey, data) => ({
  type: FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS,
  payload: { uniqueKey, data },
});

export const fetchShopByLookUnbxdFailure = (uniqueKey, error) => ({
  type: FETCH_SHOP_BY_LOOK_UNBXD_FAILURE,
  payload: { uniqueKey, error },
});
